/**
 * Vitest 单元测试运行时为 true。
 * 注意：部署的测试环境使用 vite --mode test，但不应禁用远程 API；
 * 只有 Vitest 跑用例时才跳过网络请求。
 */
export const IS_VITEST = Boolean(import.meta.env.VITEST);

/**
 * 是否处于「单测运行时」——即需要跳过远程 API 的场景。
 *
 * 必须同时满足 Vitest 环境与 MODE === 'test'：
 * - `vite build --mode test` 打出的测试环境包里 VITEST 为空，远程 API 保持开启；
 * - 用例可用 `vi.stubEnv('MODE', 'development')` 显式打开远程分支。
 *
 * 保持函数形式而非常量，是为了让用例里的 stubEnv 能在运行时生效。
 */
export function isUnitTestRuntime() {
  return IS_VITEST && import.meta.env.MODE === 'test';
}
